import {InvoiceOwner} from './invoice-owner';

export class InvoiceCachedData {
  invoiceowner: InvoiceOwner;
  prefix: string;
  suffix: string;
  currencyid: number;
  currencytag: string;
}
